import React from 'react';

import { StarGray } from '@travel/icons/ui';
import { cx } from '@travel/utils';

import styles from './postReviewSkeleton.module.scss';

const PostReviewSkeleton = () => {
  const skeletonStars = (size: number) => {
    return (
      <div className={styles.starList}>
        {Array.from({ length: 5 }, (_, i) => (
          <StarGray key={i} className={styles.loadingStar} size={size} />
        ))}
      </div>
    );
  };

  const skeletonChips = (count: number) => {
    return (
      <div className={styles.chipList}>
        {Array.from({ length: count }, (_, i) => (
          <div key={i} className={styles.loadingChip} />
        ))}
      </div>
    );
  };

  return (
    <div className={styles.layout} data-testid="postPageSkeleton">
      <div className={styles.pageContents}>
        <section className={styles.section}>
          <div className={styles.title} />
          <div className={styles.reservationCard} />
          <div className={styles.overallScore}>
            <div className={styles.ratingLabel} />
            {skeletonStars(48)}
          </div>
          <div className={styles.categoryScoresWrapper}>
            {Array.from({ length: 5 }, (_, i) => (
              <div key={i} className={styles.categoryScores}>
                <div className={styles.ratingLabel} />
                {skeletonStars(32)}
              </div>
            ))}
          </div>
        </section>
        <section className={styles.section}>
          <div className={styles.mediaTitle} />
          <div className={styles.mediaDescription} />

          <div className={styles.mediaWrapper}>
            <div className={styles.media} />
            <div className={styles.media} />
            <div className={styles.media} />
            <div className={styles.media} />
            <div className={styles.media} />
            <div className={styles.media} />
          </div>
        </section>
        <section className={styles.section}>
          <div className={cx(styles.flexWrapper, styles.commentHeaderWrapper)}>
            <div className={styles.mediumLabel} />
            <div className={styles.smallLabel} />
          </div>
          <div className={styles.commentForm} />
          <div className={styles.titleLabel} />
          <div className={styles.titleForm} />
        </section>
        <section className={styles.section}>
          <div className={styles.titleLabel} />
          {skeletonChips(3)}
          <div className={styles.titleLabel} />
          {skeletonChips(6)}
          <div className={styles.titleLabel} />
          {skeletonChips(6)}
        </section>
        <section className={styles.section}>
          <div className={styles.profileLabel} />
          <div className={styles.profileWrapper}>
            <div className={styles.flexWrapper}>
              <div className={styles.profileIcon} />
              <div className={styles.profileName} />
            </div>

            <div className={styles.smallLabel} />
          </div>
          <div className={styles.titleLabel} />
        </section>
        <section className={styles.section}>
          <div className={styles.titleLabel} />
          <div className={styles.policyWrapper}>
            <div className={styles.longLabel} />
            <div className={styles.longLabel} />
            <div className={styles.halfLabel} />
          </div>
          <div className={styles.titleLabel} />
        </section>
      </div>
    </div>
  );
};

export default PostReviewSkeleton;
